// Currency — Philippine Peso (PHP) only.
export const CURRENCIES = [
  { code: "PHP", symbol: "₱", label: "Peso (PHP)" },
];

const SYM = { PHP: "₱" };

export function currencySymbol(code) {
  return SYM[code] || "₱";
}

export function fmtCurrency(amount, code = "PHP") {
  const sym = SYM[code] || "₱";
  const v = Number(amount) || 0;
  return `${sym}${v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
